import { useMutation } from "@tanstack/react-query";

import { SyncReceivedBooksFormValues } from "@modules/syncReceivedBooks/validations";

import { triggerSyncService } from "./service";
import { TriggerSyncConflictError, TriggerSyncResponse, UseTriggerSyncMutationOptions } from "./types";

export function useTriggerSyncMutation(options?: UseTriggerSyncMutationOptions) {
  return useMutation<TriggerSyncResponse, TriggerSyncConflictError, SyncReceivedBooksFormValues>({
    mutationFn: triggerSyncService,
    ...options,
  });
}
